import React from 'react'
import { globalStateContext } from "./state"

export const ShowWhenState = ({state, children}) => {
  const {selectedOutput} = React.useContext(globalStateContext);
  return selectedOutput === state ? children : null;
}